import { render, staticRenderFns } from "./VerticalDetailed.vue?vue&type=template&id=5698b91a"
import script from "./VerticalDetailed.vue?vue&type=script&lang=js"
export * from "./VerticalDetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports